"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingSubmittedEvent = exports.SubmitOnboardingCommand = void 0;
const cq_core_1 = require("@leavy/cq-core");
const base_1 = require("../../base");
const domain_events_core_1 = require("@leavy/domain-events-core");
const BaseOnboardingCommand_1 = require("./BaseOnboardingCommand");
let SubmitOnboardingCommand = class SubmitOnboardingCommand extends BaseOnboardingCommand_1.BaseOnboardingCommand {
};
SubmitOnboardingCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "submit_onboarding",
    })
], SubmitOnboardingCommand);
exports.SubmitOnboardingCommand = SubmitOnboardingCommand;
let OnboardingSubmittedEvent = class OnboardingSubmittedEvent extends domain_events_core_1.DomainEventBase {
    constructor(data) {
        super(data);
    }
};
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], OnboardingSubmittedEvent.prototype, "userId", void 0);
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], OnboardingSubmittedEvent.prototype, "onboardingId", void 0);
OnboardingSubmittedEvent = __decorate([
    (0, domain_events_core_1.DomainEvent)({ namespace: base_1.ONBOARDING_SERVICE_NAME, name: "onboarding_submitted", version: 1 }),
    __metadata("design:paramtypes", [Object])
], OnboardingSubmittedEvent);
exports.OnboardingSubmittedEvent = OnboardingSubmittedEvent;
//# sourceMappingURL=SubmitOnboardingCommand.js.map